<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">
    <h3 class="modal-title font">{{ proceso?.nombre }}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <p>{{ proceso?.descripcion }}</p>

    <form class="form-search py-3" [formGroup]="formGroup">
      <div class="row-fields">
        <div class="field field-50">
          <label for="anioOrigen">Año origen <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="anioOrigen" id="anioOrigen" placeholder="-- Año origen --">
                <mat-option *ngFor="let anio of aniosOrigen" [value]="anio">
                  {{ anio }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-50">
          <label for="anioDestino">Año destino <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="anioDestino" id="anioDestino" placeholder="-- Año destino --">
                <mat-option *ngFor="let anio of aniosDestino" [value]="anio">
                  {{ anio }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer actions">
    <div class="note"><span>* Campos Obligatorios</span></div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" [disabled]="formGroup.invalid" (click)="lanzarReplica()"
        aria-label="Lanzar réplica">Lanzar réplica</button>
    </div>
  </div>
</div>
